import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons'
import { withTranslation } from 'react-i18next';
import './relatedlinks.scss';
class RelatedLinks extends React.Component {

  render() {
    const { t, links } = this.props;
    let l = 0;
    let items = [];
    if (links) {
      l = links.length;
      items = links.map(item => {
        let internal = item.link.startsWith('https://www.nutrfy.com/');
        return (
          <>
          {internal ? 
          <li className="list-group-item"><a href={item.link} title={item.title}>{item.text}</a></li>
          :
          <li className="list-group-item"><a href={item.link} title={item.title} target="_blank" rel="noopener">{item.text}</a> <span className="external-link"><FontAwesomeIcon className="text-center" icon={faExternalLinkAlt}/></span></li>
        }
        </>
        )
      })
    }

    return (
      <>
      {l > 0 ? 
      <div>
        <h4>{t("Blog.relatedlinks._headline")}</h4>
        <ul className="list-group">
          {items}
        </ul>
      </div>
      : null }
      </>
    )
  }
}

RelatedLinks.defaultProps = {
  links: []
}

export default withTranslation()(RelatedLinks);